import { useTranslation } from 'react-i18next';

import { useKeyboardCategoryHelper } from '../../hooks/useKeyboardCategoryHelper';
import type { ArtistLinkItem } from '../../lib/types';
import { ArtistItem } from '../ArtistItem';
import { ResultSection } from '../ResultSection';
import { ShowAllCategoryResultsButton } from '../ShowAllCategoryResultsButton/ShowAllCategoryResultsButton';

export type ArtistsListProps = {
  items: ArtistLinkItem[];
};

const CATEGORY_KEY = 'artists';

export function ArtistsList({ items }: ArtistsListProps) {
  const { t } = useTranslation('wmgone');
  const { registerElement } = useKeyboardCategoryHelper({
    category: CATEGORY_KEY,
    items,
  });

  if (!items.length) {
    return null;
  }

  return (
    <ResultSection
      iconType="user-music"
      title={t('globalSearch.result.artists.title')}
    >
      {items.map((item, index) => (
        <ArtistItem
          ref={(element) => registerElement({ element, index })}
          key={item.id}
          item={item}
        />
      ))}
      <ShowAllCategoryResultsButton
        ref={(element) => registerElement({ element, index: items.length })}
        category={CATEGORY_KEY}
      />
    </ResultSection>
  );
}

ArtistsList.displayName = 'ArtistsList';
